<template>
  <nav
    class="grid-x navbar"
    :aria-label="$t('messages.navbar.label')"
    :style="[hasSidebar ? { 'justify-content': 'space-between' } : '', envBackground]"
  >
    <ul class="menu icons icon-top" role="menubar">
      <li
        v-for="(element, index) of filteredElements"
        class="navbar-item"
        :key="index"
        role="menuitem"
        :id="`nav-${element.id}-item`"
      >
        <template v-if="element.externalLink">
          <a :href="element.externalLink" target="_blank">
            <i :class="element.icon" :style="{ fontSize: mobileSizeIcons }" class="bi" aria-hidden="true"></i>
            <span v-if="element.titleLocale">{{ $t(element.titleLocale) }}</span>
            <span v-else>{{ element.title }}</span>
          </a>
        </template>
        <router-link
          v-if="element.link"
          :to="element.link"
          :class="{ selected: activeElement.title.startsWith(element.title), [element.class || '']: 'true' }"
        >
          <i :class="element.icon" :style="{ fontSize: mobileSizeIcons }" class="bi" aria-hidden="true"></i>
          <span v-if="element.titleLocale">{{ $t(element.titleLocale) }}</span>
          <span v-else>{{ element.title }}</span>
        </router-link>
      </li>
    </ul>
    <a @click="ui.toggleSidebar" class="chevron" v-if="hasSidebar">
      <i class="bi bi-chevron-up chevron-animation" :class="{ open: ui.isSidebarOpen }"></i>
    </a>
  </nav>
</template>

<script lang="ts">
import { uiOptions } from '@/config'
import { authenticationInformation } from '@/oidc/authentication'
import { determineVisualEnvColor } from '@/utils/flags'
import { computed, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { getNavElements } from './elements'

export default defineComponent({
  name: 'Navbar',
  setup() {
    const route = useRoute()
    const user = authenticationInformation().user

    const envBackground = computed(() => {
      const { from, to } = determineVisualEnvColor()
      return {
        background: `linear-gradient(to bottom, #${from} 0%, #${to} 100%)`,
      }
    })

    const elements = computed(() => {
      return getNavElements(user)
    })

    const filteredElements = computed(() => {
      return elements.value.filter((element) => element.visible === undefined || element.visible())
    })

    const activeElement = computed(() => {
      const active = elements.value.find(
        (elem, index) => index !== 0 && elem.link && route.path.startsWith(elem.link as string),
      )
      return active ? active : { title: 'no', icon: 'no' }
    })

    const hasSidebar = computed(() => {
      if (!route.meta.sidebar) {
        return false
      }
      return true
    })

    const mobileSizeIcons = computed(() => {
      let sizeValue = ''
      if (route.name) {
        if (uiOptions().mobileRoutes.includes(route.name.toString())) {
          sizeValue = 'xx-large'
        }
      }
      return sizeValue
    })

    return {
      ui: uiOptions(),
      activeElement,
      filteredElements,
      hasSidebar,
      mobileSizeIcons,
      envBackground,
    }
  },
})
</script>
